import {
  ExportPerformanceBySegmentResp,
  PerformanceAnalysisParam,
} from '@data-visualization/performance-analysis-line-chart/Types';
import { StackedChartResp } from '@data-visualization/stacked-chart/Types';
import { RetailerKpiOption, SaleType } from '@models/Products';
import { FeatureOption } from '@utils/pageConfig/Types';

export type GeneralInsightData = {
  apiParams: CollectionsApiParams;
  insightCardTitle: string;
};

export type CollectionsApiParams = PerformanceAnalysisParam & {
  selectedLineChartSaleType: SaleType;
  selectedRetailerKpiOption: RetailerKpiOption;
  selectedFeature: FeatureOption;
  currencySymbol: string;
};

export interface CollectionButtonProps {
  type: string;
}

export type PaCollectionsApiResp = StackedChartResp | ExportPerformanceBySegmentResp;

/**
 * Enum to specficy the type of insight,
 * should be populated as more collection are implemented
 */

export enum CollectionInsightType {
  PerformanceAnalysisLineChart = 'PerformanceAnalysisLineChart',
  PerformanceAnalysisStackedBarChart = 'PerformanceAnalysisStackedBarChart',
  CategoryLeaderboardBarChart = 'CategoryLeaderboardBarChart',
  OpportunityReviewBubbleChart = 'OpportunityReviewBubbleChart',
  RetailerOverviewCombinedChart = 'RetailerOverviewCombinedChart',
  RetailerOverviewLineChart = 'RetailerOverviewLineChart',
  ExploreBarChart = 'ExploreBarChart',
  ExploreLineChart = 'ExploreLineChart',
  TrendStackBarChart = 'TrendStackBarChart',
  ExploreSegmentsStackedBarChart = 'ExploreSegmentsStackedBarChart',
  TradingAssistantButterflyChart = 'TradingAssistantButterflyChart',
  ProductTrendsMarketRetailerLineChart = 'ProductTrendsLineChart',
  ProductsDoubleBarChart = 'ProductsDoubleBarChart',
}

export interface CollectionLiveData {
  isUsingCollectionLiveData?: boolean;
}
